<template>
  <div style="display:inline-block">
    <span class="ft_inch_val" >
      <inputValidateBox :rules="rules.number" prop='ft1' style="display: inline-block;">
        <el-input @input="testDigital($event, 'ft1')" :class="unitData === 'T_FEET_FRACTION' ? 'input1' : 'input2'" :disabled='disabledFlag' v-model="ft1" @blur="$emit('blur', changeft())" @keyup.enter.native="$emit('blur', changeft())"></el-input>
      </inputValidateBox>
    </span>
    <span :class="{'ftnone':ftFlag}" v-if="isSimple">'</span>
    <span :class="{'ftnone':ftFlag}" v-else>ft</span>
    <span class="ft_inch_val">
      <inputValidateBox :rules="rules.number" prop='ft2' style="display: inline-block;">
        <el-input @input="testDigital($event, 'ft2')" :class="unitData === 'T_FEET_FRACTION' ? 'input2' : 'input3'" :disabled='disabledFlag' v-model="ft2" @blur="$emit('blur', changeft())" @keyup.enter.native="$emit('blur', changeft())"></el-input>
      </inputValidateBox>
    </span>
    <span :class="{'ftnone':!ftFlag}">/</span>
    <span class="ft_inch_val">
      <inputValidateBox :rules="rules.number" prop='ft3' style="display: inline-block;">
        <el-input @input="testDigital($event, 'ft3')" :class="unitData === 'T_FEET_FRACTION' ? 'input3' : 'input4'" :disabled='disabledFlag' v-model="ft3" @blur="$emit('blur', changeft())" @keyup.enter.native="$emit('blur', changeft())"></el-input>
      </inputValidateBox>
    </span>
    <span :class="{'ftnone':ftFlag}">/</span>
    <span class="ft_inch_val" :class="{'ftnone':ftFlag}">
      <inputValidateBox :rules="rules.number" prop='ft4' style="display: inline-block;">
        <el-input @input="testDigital($event, 'ft4')" class="input4" v-model="ft4" @blur="$emit('blur', changeft())" :disabled='disabledFlag' @keyup.enter.native="$emit('blur', changeft())"></el-input>
      </inputValidateBox>
    </span>
    <span v-if="isSimple">"</span>
    <span v-else>inch</span>
  </div>
</template>

<script>
import inputValidateBox from '@/components/inputValidateBox'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  name: 'ftInput',
  data () {
    return {
      ft1: '',
      ft2: '',
      ft3: '',
      ft4: '',
      rules: {
        'number': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'}
        ]
      },
      AllVal: ''
    }
  },

  model: {
    prop: 'ftInchData',
    event: 'blur'
  },

  props: {
    ftInchData: {
      type: String,
      default: ''
    },

    unitData: {
      type: String,
      default: ''
    },

    disabledFlag: {
      type: Boolean,
      default: false
    },

    forceUpdate: {
      type: Boolean,
      default: false
    }
  },

  components: {
    inputValidateBox
  },

  watch: {
    ftInchData (newValue, oldValue) {
      this.getft()
    },
    forceUpdate (newValue, oldValue) {
      if (newValue) {
        this.getft()
      }
    }
  },

  computed: {
    ...mapState([
      'graph',
      'isSimple'
    ]),
    ftFlag () {
      return this.unitData === 'T_INCH_FRACTION'
    }

    // unitData: {
    //   get () {
    //     return this.graph.unit
    //   },

    //   set (value) {
    //     this.SET_UNIT(value)
    //   }
    // }
  },

  mounted () {
    this.initData()
  },

  methods: {
    ...mapMutations([
      'SET_GRAPH_ROOMW',
      'SET_UNIT'
    ]),

    initData () {
      this.getft()
    },
    testDigital (e, key) {
      e = e.replace(/[^ \d]/ig, '')
      this[key] = e
    },
    changeft () {
      if (this.unitData === 'T_FEET_FRACTION') {
        if (this.ft1 === '') {
          this.ft1 = '0'
        }
        if (this.ft2 === '') {
          this.ft2 = '0'
        }
        if (this.ft3 === '') {
          this.ft3 = '0'
        }
        if (this.ft4 === '' || this.ft4 === '0') {
          this.ft4 = '16'
        }
        this.AllVal = this.ft1 + "' " + this.ft2 + '-' + this.ft3 + '/' + this.ft4 + '"'
      } else if (this.unitData === 'T_INCH_FRACTION') {
        if (this.ft1 === '') {
          this.ft1 = '0'
        }
        if (this.ft2 === '') {
          this.ft2 = '0'
        }
        if (this.ft3 === '' || this.ft3 === '0') {
          this.ft3 = '16'
        }
        this.AllVal = this.ft1 + ' ' + this.ft2 + '/' + this.ft3 + '"'
      }
      return this.AllVal
    },

    getft () {
      if (this.unitData === 'T_FEET_FRACTION') {
        let itemVal = this.ftInchData.split("'")
        if (itemVal.length < 2) return
        let itemVal1 = itemVal[1].split('/')
        let itemVal2 = itemVal1[0].split(' ')
        let itemVal2T = itemVal1[1].split('"')
        let itemVal3 = itemVal2[1].split('-')
        this.ft1 = itemVal[0]
        this.ft2 = itemVal3[0]
        this.ft3 = itemVal3[1]
        this.ft4 = itemVal2T[0]
      } else if (this.unitData === 'T_INCH_FRACTION') {
        if (this.ftInchData.split(' ').length > 1) {
          let IitemVal = this.ftInchData.split(' ')
          let IitemVal1 = IitemVal[1].split('"')
          let IitemVal2 = IitemVal1[0].split('/')
          this.ft1 = IitemVal[0]
          this.ft2 = IitemVal2[0]
          this.ft3 = IitemVal2[1]
        } else {
          let IitemVal = this.ftInchData.split('"')
          this.ft1 = IitemVal[0]
          this.ft2 = 0
          this.ft3 = 1
        }
      }
    }
  }
}

</script>
<style scoped>
.ftnone {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ftInput.vue